<section>
  <app-admin-card>
    <form class="cg-admin-form-grid" (ngSubmit)="submit()">
      <label class="cg-admin-field cg-admin-field--full">
        <span class="cg-admin-field__label">Name</span>
        <input class="cg-input" [(ngModel)]="name" name="name" required />
      </label>
      <label class="cg-admin-field">
        <span class="cg-admin-field__label">Code</span>
        <input class="cg-input" [(ngModel)]="code" name="code" placeholder="e.g. NYC01" required />
      </label>
      <label class="cg-admin-field">
        <span class="cg-admin-field__label">Admin email</span>
        <input class="cg-input" type="email" [(ngModel)]="adminEmail" name="adminEmail" required />
      </label>
      <label class="cg-admin-field cg-admin-field--full">
        <span class="cg-admin-field__label">Contact phone</span>
        <input class="cg-input" [(ngModel)]="contactPhone" name="contactPhone" />
      </label>
      @if (error()) {
        <p class="cg-form-error cg-admin-field--full" role="alert">{{ error() }}</p>
      }
      <div class="cg-admin-field--full flex flex-wrap gap-2">
        @if (showCreate()) {
          <app-admin-button variant="primary" type="submit" [disabled]="saving()">
            {{ saving() ? 'Creating…' : 'Create franchise' }}
          </app-admin-button>
        }
        <app-admin-button variant="cancel" type="button" (click)="cancel()">Cancel</app-admin-button>
      </div>
    </form>
  </app-admin-card>
</section>
